import { taskTemplateSchema } from "@/components/Forms/schema/taskTemplateSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createResourceSelector } from "jsonapi-zod-query";

const taskTemplateTypeSelector = createResourceSelector({
    type: "taskTemplate",
    attributesSchema: taskTemplateSchema,
});

export type TaskTemplate = ReturnType<typeof taskTemplateTypeSelector>;

type Props = {
    taskTemplateUUID: string | null;
    isQueryEnabled?: boolean;
};

export const useFetchTaskTemplate = ({
    isQueryEnabled = true,
    taskTemplateUUID,
}: Props): UseQueryResult<TaskTemplate> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: ["task-templates", taskTemplateUUID],
        enabled: isQueryEnabled,
        queryFn: async () => {
            const fetchURL = apiUrl(`/task-template/by-id/${taskTemplateUUID}`);

            const response = await fetch(fetchURL.href, {
                method: "GET",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
            });

            return await response.json();
        },
        select: taskTemplateTypeSelector,
    });
};
